import styles from './device-card.module.scss';

/**
 * A card-shaped loading placeholder.
 *
 * Deliberately styled from `device-card.module.scss` rather than a stylesheet of its own: it reads
 * the same `$card-min-height` / `$card-padding` the real card does, so the two can't drift and the
 * grid doesn't reflow when the first batch arrives.
 */
export function DeviceCardSkeleton() {
  return <div className={styles.skeleton} data-testid="device-card-skeleton" />;
}
